import { CaretDownIcon, CaretRightIcon } from '@phosphor-icons/react';
import { useGT } from 'gt-react';

export function RebateAnalyticsCollapseToggle({
  isCollapsed,
  onToggle,
  testId,
}: {
  isCollapsed: boolean;
  onToggle: () => void;
  testId?: string;
}) {
  const gt = useGT();
  return (
    <button
      type="button"
      data-testid={testId}
      className="flex-shrink-0 text-muted-foreground hover:text-foreground p-0.5 rounded transition-colors cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      title={
        isCollapsed
          ? gt('Expand', {
              context: 'expand rebate analytics table card',
            })
          : gt('Collapse', {
              context: 'collapse rebate analytics table card',
            })
      }
    >
      {isCollapsed ? (
        <CaretRightIcon className="h-3.5 w-3.5" />
      ) : (
        <CaretDownIcon className="h-3.5 w-3.5" />
      )}
    </button>
  );
}
